import {createContext, useContext} from "react";
import {useLocalStorage} from "usehooks-ts";

export type AuthStatus = {
  isLoggedIn: boolean,
  setIsLoggedIn: (isLoggedIn: boolean) => void
}

const AuthContext = createContext({isLoggedIn: false, setIsLoggedIn: () => {}} as AuthStatus);

const AUTH_STATUS_KEY = "authStatus";

export function AuthProvider({children}: {children: React.ReactNode}) {
  const [status, setStatus] = useLocalStorage<string | null>(AUTH_STATUS_KEY, null);

  return (
    <AuthContext.Provider value={{
      isLoggedIn: status === "loggedIn",
      setIsLoggedIn: (loggedIn: boolean) => {
        setStatus(loggedIn ? "loggedIn" : null);
      }
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
